import React, { useState, useRef } from "react";
import "../styles/contact.css";
import Button from "../components/Button";
import mailIcon from "../assets/mail.svg";
import buildingIcon from "../assets/building.svg";
import clockIcon from "../assets/clock.svg";
import emailjs from "@emailjs/browser";
import banner from "../assets/123.webp";
const Contact = () => {
  const [from_name, setFrom_name] = useState("");
  const [from_email, setFrom_email] = useState("");
  const [message, setMessage] = useState("");

  const handleChange_from_name = (e) => {
    setFrom_name(e.target.value);
  };
  const handleChange_from_email = (e) => {
    setFrom_email(e.target.value);
  };
  const handleChange_message = (e) => {
    setMessage(e.target.value);
  };

  const sendEmail = (e) => {
    e.preventDefault();

    const form = {
      from_name: from_name,
      message: message,
      from_email: from_email
    };

    emailjs
      .send("service_de647zl", "template_mukdzd5", form, "H7-qqgvvD8VexqK1X")
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    return;
  };

  return (
    <div>
      <img
        src={banner}
        alt="github Icon"
        className="banner"
      />
      <div className="overlay"></div>
      <div className="word">
        <span>This repository is developed and maintained by the</span>
        <a
          className="contact-us-links alianjie"
          target="_blank"
          style={{ marginLeft: '10px',color:'red' }}
          href="https://personal.ntu.edu.sg/boan/"
        >
          AMI
        </a>{" "}
        group
        at{" "}
        <div>
          <a
            className="contact-us-links alianjie"
            target="_blank"
            href="https://www.ntu.edu.sg/"
          >
            Nanyang Technological University.
          </a>
        </div>
      </div>
      <div className="container" style={{}}>
        <div className="row">
          <div className="col" style={{ width: '50%', float: 'left' }}>
            <h1 id="contact-us-header" className="Name111">Contact Us</h1>
            <p id="contact-us-info">
              We will get back to you as soon as we Can!
            </p>

            <div className="row my-2">
              <div htmlFor="floatingInput">Name</div>
              <div className="col">
                <input
                  placeholder="Please Input Your Name"
                  className="form-control"
                  id="floatingInput"
                  style={{ marginTop: '10px' }}
                  onChange={(e) => {
                    handleChange_from_name(e);
                  }}
                ></input>
                {/* <label htmlFor="floatingInput">Name</label> */}
              </div>
            </div>
            <div className="row my-2">
              <div className="col">
                <div htmlFor="floatingInput">Email</div>
                <input
                  type="email"
                  className="form-control"
                  id="floatingInput"
                  placeholder="Please Input Your Email"
                  style={{ marginTop: '10px' }}
                  onChange={(e) => {
                    handleChange_from_email(e);
                  }}
                ></input>

              </div>
            </div>
            <div className="row my-2">
              <div className=" col">
                <div htmlFor="floatingInput">Message</div>
                <input
                  className="form-control"
                  placeholder="Please Input Your Message"
                  id="floatingInput"
                  style={{ marginTop: '10px' }}
                  onChange={(e) => {
                    handleChange_message(e);
                  }}
                ></input>
                {/* <label htmlFor="floatingInput">Message</label> */}
              </div>
            </div>
            <div className='send' onClick={(e) => sendEmail(e)}>
              SEND
            </div>
          </div>
          <div className="offset-1 col " style={{ width: '50%', float: 'right' }}>
            <div className="info-box">

              <div className="info-inner-box">
                <h1 style={{ fontWeight: 700, fontSize: '30px' }}  className="Name111">Info</h1>
                <div className="flex-row" style={{ marginTop: '50px' }}>
                  <img
                    src={mailIcon}
                    alt="github Icon"
                    className="info-box-icon"
                  />
                  <p>TradeMaster.NTU@gmail.com</p>
                </div>
                <div className="flex-row" style={{ marginTop: '30px' }}>
                  <img
                    src={buildingIcon}
                    alt="github Icon"
                    className="info-box-icon"
                  />
                  <p>ABN 03a-03/04/05, 61 Nanyang Drive Singapore 637335</p>
                </div>
                <div className="flex-row" style={{ marginTop: '30px' }}>
                  <img
                    src={clockIcon}
                    alt="github Icon"
                    className="info-box-icon"
                  />
                  <p>9am - 6pm</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
